import { render, staticRenderFns } from "./LengkapiMaterial.vue?vue&type=template&id=fe4ffe00&scoped=true"
import script from "./LengkapiMaterial.vue?vue&type=script&lang=js"
export * from "./LengkapiMaterial.vue?vue&type=script&lang=js"
import style0 from "./LengkapiMaterial.vue?vue&type=style&index=0&id=fe4ffe00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4ffe00",
  null
  
)

export default component.exports